<template>
  <div id class="grey lighten-4 pb100">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="9" xl="8">
          <v-card>
            <div class="video-responsive">
              <iframe
                :src="videoIframe"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                autoplay
                allowfullscreen
              ></iframe>
            </div>
            <v-container fluid>
              <v-row>
                <v-col cols="12" lg="12">
                  <h3>{{$store.state.website.about.title}}</h3>
                </v-col>
                <v-col cols="12" lg="12">
                  <div v-html="$store.state.website.about.text"></div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center">
          <h1>At Our Core</h1>
        </v-col>
      </v-row>
      <v-divider class="mb-4 mt-2"></v-divider>
      <v-row justify="center" align="center">
        <v-col
          v-for="(profile,i) in $store.state.website.about.members"
          :key="i"
          cols="10"
          md="4"
          lg="3"
        >
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 12 : 2">
              <img style="width:100%;height:auto" :src="profile.picture" />

              <v-card-title>
                {{profile.name}}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>{{profile.bio}}</v-card-text>
              <v-card-actions class="grey lighten-3" v-if="profile.profile">
                <v-btn block color="secondary" target="_blank" :href="profile.profile">Video Profile</v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    frame_loaded: true
  }),
  methods: {
    frameLoaded() {
      this.frame_loaded = true;
    }
  },
  computed: {
    videoIframe() {
      if (!this.$store.state.website.about.video) {
        return "";
      }
      return this.$helpers.iframeFromUrl(
        this.$store.state.website.about.video.url
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
